import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Bienvenue sur mon Portfolio.`}</h1>
    <p>{`Je suis un étudiant à l'ESGI qui passe la plupart de son temps à jouer et à coder :)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      